'use strict';

angular.module('ClinicApp').factory('WebSocketsService', ($q, ClinicConfig, OCLogUtil) => {

  // Sails sockets setup.
  io.sails.environment = ['production', 'staging', 'demo'].includes(ClinicConfig.ENV) ? 'production' : 'development';

  let socket;

  function debugLog(message) {
    if (ClinicConfig.ENV === 'development') {
      console.log(message);
    }
  }

  const self = {

    /**
     * Creates a socket connection with the server.
     *
     * @returns Sails socket instance (https://sailsjs.com/documentation/reference/web-sockets/socket-client/sails-socket)
     */
    _createSocketConnection: () => {
      const deferred = $q.defer();

      if (socket) {
        deferred.resolve(socket);

        return deferred.promise;
      }

      // Create a Sails socket.
      // https://sailsjs.com/documentation/reference/web-sockets/socket-client/sails-socket
      socket = io.sails.connect(ClinicConfig.HOSTNAME, {
        timeout: 10000,
        reconnection: true,
        reconnectionDelay: 10000,
        reconnectionAttempts: 30,
      });

      socket.on('connect', () => {
        deferred.resolve(socket);
      });

      ['connect_error', 'connect_timeout', 'error'].forEach((eventName) => {
        socket.on(eventName, (event) => {
          const message = `[WS] Socket ${eventName}`;

          OCLogUtil.rollbar.error(message, {
            event,
          });

          deferred.reject(new Error(message));
        });
      });

      return deferred.promise;
    },

    _subscribeToServerEvent: (subscriptionUrl, onEvent) => {
      return self._createSocketConnection().then((socket) => {
        const deferred = $q.defer();

        const subscribe = () => {
          socket.get(subscriptionUrl, (body, jwres) => {
            if (jwres.error) { // jwres => JSON WebSocket Response
              return deferred.reject(new Error(`[WS] Socket subscription error: ${jwres.error.message}`));
            }

            debugLog(`[WS] Socket subscribed to the server: ${JSON.stringify(body)}`);

            socket.on(body.eventName, () => {
              onEvent();
            });

            deferred.resolve(socket);
          });
        };

        subscribe();

        socket.on('reconnect', subscribe);

        return deferred.promise;
      });
    },

    subscribeToAppointmentHistoryUpdates: (appointmentId, onEvent) => {
      return self._subscribeToServerEvent(`/ws/clinic/appointment/${appointmentId}/historyUpdatesSubscription`, onEvent);
    },

    subscribeToAppointmentSyncUpdates: (appointmentId, onEvent) => {
      return self._subscribeToServerEvent(`/ws/clinic/appointment/${appointmentId}/syncUpdatesSubscription`, onEvent);
    },

    subscribeToAppointmentStatusUpdates: (clinicId, onEvent) => {
      return self._subscribeToServerEvent(`/ws/clinic/${clinicId}/appointment/status`, onEvent);
    },

  };

  return self;
});
